// @ts-nocheck
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { CdkPortal, TemplatePortal } from '@angular/cdk/portal';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, inject } from '@angular/core';

@Component({
    selector: 'lbca-options',
    templateUrl: './options.component.html',
    styleUrl: './options.component.scss',
    imports: [CdkPortal]
})
export class OptionsComponent {
	private overlay = inject(Overlay);

	@Output('selectOption') selectEmmiter = new EventEmitter();
	@Output('closeNestedOpt') closeEmmiter = new EventEmitter();

	private overlayRef!: OverlayRef;

	@ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
	@ViewChild('templateAppend', { static: true }) templateAppend!: TemplatePortal;

	private opened = false;
	public returnObject = null;

	@Input('options')
	set optionsToChoise(opt: Array<any>) {
		this.options = opt;
	}

	@Input('close')
	set closeOption(opt: boolean) {
		this.closeSelectBox();
	}

	public options: unknown[] = [];

	ngAfterViewInit(): void {
		this.createOverlayRef();
	}

	troggleOptionBox(event) {
		event.stopPropagation();
		this.opened ? this.closeSelectBox() : this.openSelectBox();
	}

	private openSelectBox(): void {
		if (this.overlayRef.hasAttached()) return;
		this.closeEmmiter.emit(true);
		setTimeout(() => {
			this.overlayRef.attach(this.templateAppend);
			this.opened = true;
		}, 20);
	}

	public closeSelectBox(): void {
		if (!this.overlayRef) return;
		setTimeout(() => this.overlayRef.detach(), 1);
		this.opened = false;
	}

	// need refactor
	private createOverlayRef(): void {
		// const positionStrategy = this.overlay
		// 	.position()
		// 	.connectedTo(
		// 		this.mainElement,
		// 		{ originX: 'start', originY: 'bottom' },
		// 		{ overlayX: 'start', overlayY: 'top' },
		// 	);
		// const scrollStrategy: ScrollStrategy = this.overlay.scrollStrategies.close();
		// const config = new OverlayConfig({ positionStrategy, scrollStrategy });
		// this.overlayRef = this.overlay.create(config);
	}

	selectOption(option) {
		this.selectEmmiter.emit(option);
	}

	@HostListener('document:click', ['$event']) clickGlobalEvent(event) {
		if (this.opened) this.closeSelectBox();
	}
}
